import api from './api';

export const peritosService = {
  listar: (q = '', page = 0, size = 25) =>
    api.get('/peritos', { params: { q, page, size } }),

  obtener: (id) =>
    api.get(`/peritos/${id}`),

  crear: (data) =>
    api.post('/peritos', data),

  actualizar: (id, data) =>
    api.put(`/peritos/${id}`, data),

  eliminar: (id) =>
    api.delete(`/peritos/${id}`),
};
